var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReloadRight = function SvgReloadRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 17",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.029 7.629 1.228-1.293 1.228-1.229a.875.875 0 0 1 1.1 0l1.228 1.294L7.04 7.629c.324.259.194.517-.258.517H5.296c0 3.168 2.586 5.754 5.754 5.754a5.711 5.711 0 0 0 4.073-1.68l1.94 1.939c-1.488 1.551-3.686 2.521-6.013 2.521-4.655 0-8.47-3.814-8.47-8.534H1.287c-.452 0-.582-.258-.258-.517ZM15.123 8.987c-.323-.259-.194-.582.194-.582h1.487c0-3.168-2.586-5.754-5.754-5.754a5.512 5.512 0 0 0-4.073 1.745l-1.94-1.94C6.59.97 8.722 0 11.05 0c4.72 0 8.534 3.814 8.534 8.47h1.422c.453 0 .582.258.259.581l-1.229 1.229-1.228 1.293a.875.875 0 0 1-1.1 0l-1.227-1.293-1.358-1.293Z"
  })));
};

export default SvgReloadRight;